import {
  createSlice,
  PayloadAction,
  createAsyncThunk,
  createDraftSafeSelector,
} from "@reduxjs/toolkit";
import { RootState } from "store";
import { get } from "lodash";
import moment from "moment";
import { Bot, UserInfo, UserProfile, LoginInfo } from "types/user";
import {
  showBotLoadingMessage,
  hideBotLoadingMessage,
  pushBotMessage,
  pushSelfMessage,
  mapInputValue,
  setInputValue,
  setMessages,
  resetChatSlice,
} from "store/reducers/chat";
import UserService from "services/auth";
import { MessageType, LoginFlow } from "types/chat";
import { setAllMessages, setLocale } from "store/reducers/intl";

import { StatusCode } from "libs/http/constant";
import storage from "libs/storage";
import { PHONEREG } from "libs/regex";
import getFilePrefix from "libs/getFilePrefix";
import formatPosition from "libs/formatPosition";
import formatCompany from "libs/formatCompany";
import history from "libs/history";
import isLocalhost from "libs/isLocalhost";

import { Modal, message } from "antd";
// import userDefaultAvatar from "components/avatar/user.svg";
// import botDefaultAvatar from "components/avatar/bot.png";
import { isLogin } from "store/reducers/login";
// import log from "@hrtps/log";

const { confirm } = Modal;

export const loginAuthCodeCountdownKey = "LOGIN_AUTH_CODE_COUNTDOWN_KEY";
export const loginTempoaryPhoneKey = "LOGIN_TEMPOARY_PHONE_KEY";
export const sendAuthCodeMinDuration = 60;

// export function isLogin() {
//   const token = storage.getToken();
//   const isValidToken = token && token !== "undefined" && token !== "null";
//   if (!isValidToken) {
//     storage.setToken("");
//   }
//   return isValidToken;
// }

export function logout() {
  storage.setToken("");
  hasCountDownMessage = false;
}

let onIndentitySwitchLoading = false;

export const onIndentitySwitch = createAsyncThunk(
  "user/onIndentitySwitch",
  (arg: any, thunkAPI) => {
    if (onIndentitySwitchLoading) return;
    onIndentitySwitchLoading = true;
    const message = get(arg, "message");
    const token = get(arg, "token");

    message &&
      token &&
      Modal.success({
        title: message,
        centered: true,
        icon: null,
        onOk() {
          storage.setToken(token);
          window.location.reload();
        },
        okText: "确定",
      });
  }
);

export const toLoginPage = createAsyncThunk(
  "user/toLoginPage",
  (arg: any, thunkAPI) => {
    logout();
    const dispatch = thunkAPI.dispatch;
    dispatch(resetChatSlice());
    dispatch(resetUserSlice());
    const preCompanyId = `${storage.getCompanyID()}`;
    const filtedCompanyId = preCompanyId.match(/\d+/g);
    const companyId = filtedCompanyId ? `?companyID=${filtedCompanyId}` : "";
    const prefix = isLocalhost() ? "/#/login" : "/chatbot-pc/#/login";
    window.location.href = `${window.location.origin}${prefix}${companyId}`;
  }
);

export function modifyLoginPhone(phone: string) {
  logout();
  storage.setPhone(phone);
  window.location.reload();
}

export const getUserInfo = createAsyncThunk(
  "user/getUserInfo",
  async (arg: any, thunkAPI) => {
    const res = await UserService.userCenter();
    const success = get(res, "code") === StatusCode.success;
    const result = get(res, "result");
    if (success) {
      return result;
    }
  }
);

export const getUserProfile = createAsyncThunk(
  "user/getUserProfile",
  async (arg: any, thunkAPI) => {
    const res = await UserService.userProfile();
    const success = get(res, "code") === StatusCode.success;
    const result = get(res, "result");
    if (success) {
      return result;
    }
  }
);

export const getBot = createAsyncThunk(
  "user/getBot",
  async (arg: any, thunkAPI) => {
    try {
      const res = await UserService.getBot();

    //   try {
    //     log.init({
    //       env: process.env.REACT_APP_ENV || "DEV",
    //       tenantId: "SSC-C-PC",
    //       serviceCode: "SSC-C-PC",
    //     });
    //     log.info(
    //       `[company_id: ${storage.getCompanyID()}] [bot_name: ${get(
    //         res,
    //         "result.bot_name"
    //       )}]`
    //     );
    //   } catch (e) {
    //     console.log("日志初始化失败：", e);
    //   }

      const success = get(res, "code") === StatusCode.success;
      const result = get(res, "result") as any;
      if (success) {
        const botName = get(result, "bot_name");
        if (botName) {
          document.title = botName;
        }

        const dispatch = thunkAPI.dispatch;
        const locale = get(result, "locale");
        const constants = get(result, "constants");
        dispatch(setAllMessages(constants));
        // @ts-ignore
        dispatch(setLocale(locale));
        dispatch(setBot(result));
        return result;
      }
    } catch (e) {
      console.log(e);
    }
  }
);

const initAuthCodeCountdown = createAsyncThunk(
  "user/initAuthCodeCountdown",
  async ({ phone }: { phone: string }, thunkAPI) => {
    // const preTempoaryPhone = storage.getItem(loginTempoaryPhoneKey);

    // const preCountdownRaw = storage.getItem(loginAuthCodeCountdownKey);
    const now = moment();
    // const preCountdown = moment(
    //   // preTempoaryPhone && phone !== preTempoaryPhone
    //   //   ? now.add(1, "days")
    //   //   :
    //   parseInt(preCountdownRaw as any, 10)
    // );
    const dispatch = thunkAPI.dispatch;

    const startCountdown = (last?: number) => {
      const state = thunkAPI.getState() as RootState;
      const pre = last || mapAuthCodeCountdown(state);
      if (pre > 0) {
        dispatch(setLoginInfo({ authCodeCountdown: pre - 1 }));
        setTimeout(() => {
          !isLogin() && startCountdown();
        }, 1000);
      } else {
        dispatch(setLoginInfo({ authCodeCountdown: sendAuthCodeMinDuration }));
      }
    };

    storage.setItem(loginAuthCodeCountdownKey, now.valueOf());
    storage.setItem(loginTempoaryPhoneKey, phone);
    startCountdown();

    // if (preCountdown.isValid()) {
    //   const duration = moment.duration(now.diff(preCountdown));
    //   var seconds = duration.asSeconds();
    //   if (seconds > sendAuthCodeMinDuration) {
    //     storage.setItem(loginAuthCodeCountdownKey, now.valueOf());
    //     startCountdown();
    //   } else {
    //     const last = (sendAuthCodeMinDuration - seconds) as any;
    //     startCountdown(parseInt(last, 10));
    //     dispatch(
    //       pushBotMessage([
    //         {
    //           data: { content: "短信验证码已发送" },
    //           type: MessageType.client_authcode_countdown,
    //         },
    //         `发送短信验证码间隔不少于${sendAuthCodeMinDuration}s`,
    //       ])
    //     );
    //     throw new Error();
    //   }
    // } else {
    //   storage.setItem(loginAuthCodeCountdownKey, now.valueOf());
    //   storage.setItem(loginTempoaryPhoneKey, phone);
    //   startCountdown();
    // }
  }
);

// let alreadySend = false;
let hasCountDownMessage = false;

export const sendAuthCode = createAsyncThunk(
  "user/sendAuthCode",
  async (phone: string, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const loginPhone = mapLoginInfo(state).loginPhone;
    phone = phone || loginPhone;
    if (!phone) return;

    const dispatch = thunkAPI.dispatch;
    // const timer = await dispatch(initAuthCodeCountdown({ phone }));
    // if (get(timer, "error")) return;

    dispatch(showBotLoadingMessage({}));
    const res = await UserService.getCode(phone);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    dispatch(hideBotLoadingMessage({}));

    const successDefaultMessage = "短信验证码已发送";
    const errorDefaultMessage = "发送手机短信验证码失败，请重试";
    const code = get(res, "code");
    const message = get(res, "message", errorDefaultMessage);

    if (code === StatusCode.success) {
      const payload = hasCountDownMessage
        ? [successDefaultMessage]
        : [
            successDefaultMessage,
            {
              data: { content: "请输入验证码" },
              type: MessageType.client_authcode_countdown,
            },
          ];
      !hasCountDownMessage && (hasCountDownMessage = true);
      dispatch(pushBotMessage({ payload }));
      await dispatch(initAuthCodeCountdown({ phone }));
    } else {
      const payload = hasCountDownMessage
        ? [errorDefaultMessage]
        : [
            errorDefaultMessage,
            {
              data: { content: message },
              type: MessageType.client_authcode_countdown,
            },
          ];
      !hasCountDownMessage && (hasCountDownMessage = true);

      dispatch(
        pushBotMessage({
          payload,
        })
      );
    }

    //   if (code !== StatusCode.success) {
    //     if (!hasCountDownMessage) {
    //       hasCountDownMessage = true;
    //       dispatch(
    //         pushBotMessage({
    //           payload: {
    //             data: { content: message },
    //             type: MessageType.client_authcode_countdown,
    //           },
    //         })
    //       );
    //     }
    //     throw new Error();
    //   }

    // if (!alreadySend) {
    //   hasCountDownMessage = true;
    //   dispatch(
    //     pushBotMessage({
    //       payload: [
    //         "短信已发送",
    //         {
    //           data: { content: "请输入验证码" },
    //           type: MessageType.client_authcode_countdown,
    //         },
    //       ],
    //     })
    //   );
    //   await dispatch(initAuthCodeCountdown({ phone }));
    //   alreadySend = true;
    // } else {
    //   dispatch(pushBotMessage({ payload: ["短信已发送"] }));
    // }
    // return res as any;
  }
);

export const resendAuthCode = createAsyncThunk(
  "user/resendAuthCode",
  (arg: any, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    // alreadySend = true;
    dispatch(sendAuthCode(""));
  }
);

export const handleLoginSuccess = createAsyncThunk(
  "user/handleLoginSuccess",
  (
    {
      message = "登录成功",
      btnMessage = "确定",
    }: {
      message: string;
      btnMessage: string;
      companyName?: string;
      companyIcon?: string;
    },
    thunkAPI
  ) => {
    const dispatch = thunkAPI.dispatch;
    dispatch(setMessages([]));
    dispatch(setLoginInfo(loginInfoInit));
    const modal = Modal.success({
      title: message,
      okText: btnMessage,
      onOk() {
        history.push("/welcome");
      },
      centered: true,
    });
    setTimeout(() => {
      modal && modal.destroy();
      history.push("/welcome");
    }, 1000);
  }
);

export const login = createAsyncThunk(
  "user/login",
  async (
    {
      company_id,
      bot_id,
      phone,
      auth_code,
    }: {
      company_id: string;
      bot_id?: string;
      phone: string;
      auth_code: string;
    },
    thunkAPI
  ) => {
    const dispatch = thunkAPI.dispatch;
    try {
      dispatch(showBotLoadingMessage({}));
      logout();
      const res = await UserService.loginWithPhoneCode({
        company_id,
        bot_id,
        phone,
        auth_code,
      });
      dispatch(hideBotLoadingMessage({}));
      const token = get(res, "result.token");
      if (token) {
        storage.setToken(token);
        storage.setCompanyID(company_id);
      }
      const code = get(res, "code");
      const message = get(res, "message");
      const success = code === StatusCode.success;
      const greeting = get(res, "result.button_info.greeting");
      const btn = get(res, "result.button_info.button");
      if (success) {
        dispatch(
          // @ts-ignore
          handleLoginSuccess({ message: greeting || message, btnMessage: btn })
        );
        // confirm({
        //   title: greeting || message || "登录成功",
        //   okText: btn || "确定",
        //   cancelButtonProps: { style: { display: "none" } },
        //   onOk() {
        //     return new Promise((resolve, reject) => {
        //       setTimeout(() => {
        //         window.location.reload();
        //       }, 1000);
        //     });
        //   },
        // });
      } else if (message) {
        dispatch(pushBotMessage({ payload: message }));
        // confirm({
        //   title: message,
        //   okText: "确定",
        //   cancelButtonProps: { style: { display: "none" } },
        //   onOk() {
        //     return new Promise((resolve, reject) => {
        //       resolve({});
        //       // setTimeout(() => {
        //         // window.location.reload();
        //       // }, 1000);
        //     });
        //   },
        // });
      }
      await new Promise((resolve) => setTimeout(resolve, 1000));
      return res as any;
    } catch (e) {
      console.log(e);
      dispatch(hideBotLoadingMessage({}));
    }
  }
);

export const getCompanies = createAsyncThunk(
  "user/getCompanies",
  async (
    { loginPhone, authCode }: { loginPhone: any; authCode: any },
    thunkAPI
  ) => {
    const dispatch = thunkAPI.dispatch;
    try {
      if (!loginPhone || !authCode) return;
      const res = await UserService.getCompany(loginPhone, authCode);
      const code = get(res, "code");
      const message = get(res, "message");
      if (code === StatusCode.success) {
        const token = get(res, "result.token");
        if (token) {
          storage.setToken(token);
          const company_id = get(res, "result.company_id", "");
          company_id && storage.setCompanyID(company_id);

          const greeting = get(res, "result.button_info.greeting");
          const btn = get(res, "result.button_info.button");

          dispatch(
            handleLoginSuccess({
              message: greeting || message,
              // @ts-ignore
              btnMessage: btn,
            })
          );

          // confirm({
          //   title: greeting || message || "登录成功",
          //   okText: btn || "确定",
          //   cancelButtonProps: { style: { display: "none" } },
          //   onOk() {
          //     return new Promise((resolve, reject) => {
          //       setTimeout(() => {
          //         window.location.reload();
          //       }, 1000);
          //     });
          //   },
          // });
          // greeting && btn
          //   ? showUserIdentity(greeting, btn)
          //   : window.location.reload();
          return;
        }
        const card_list = get(res, "result.card_list", []);
        const company_infos = get(res, "result.company_infos");
        // @ts-ignore
        if (Array.isArray(company_infos) && company_infos.length > 0) {
          const msg = [
            ...card_list,
            {
              type: MessageType.client_chose_companies,
              data: company_infos,
            },
          ];
          dispatch(pushBotMessage({ payload: msg }));
          // setMessages((pre: any) => [...pre, msg]);
        }
      } else if (message) {
        // const msg = generateBotMessage(message);
        // dispatch(pushMessage(msg));
        dispatch(pushBotMessage({ payload: message }));
      }
      // console.log('res: ', res);
    } catch (e) {
      console.log(e);
    }
  }
);

export const showCompanyInfos = createAsyncThunk(
  "user/showCompanyInfos",
  async (arg: any, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const dispatch = thunkAPI.dispatch;
    // const currentCompanyId = storage.getCompanyID();
    const company_infos = mapCompanyInfos(state);
    // .filter(v => `${v.company_id}` !== currentCompanyId);
    if (Array.isArray(company_infos) && company_infos.length > 0) {
      const msg = [
        {
          type: MessageType.client_chose_companies,
          data: company_infos,
        },
      ];
      dispatch(pushBotMessage({ payload: msg }));
    }
  }
);

export const validatePhone = (value: string) => PHONEREG.test(value);

export const onSignAgreement = createAsyncThunk(
  "user/onSignAgreement",
  async (arg: any, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const dispatch = thunkAPI.dispatch;
    const loginInfo = mapLoginInfo(state);
    if (loginInfo.loginPhone) {
      await dispatch(sendAuthCode(loginInfo.loginPhone));
    }
    dispatch(setLoginInfo({ signAgreement: true }));
  }
);

export const switchCompany = createAsyncThunk(
  "user/switchCompany",
  async (
    {
      company_name,
      company_id,
    }: {
      company_id: number;
      company_name: string;
    },
    thunkAPI
  ) => {
    const dispatch = thunkAPI.dispatch;
    dispatch(pushSelfMessage({ payload: company_name }));
    const hide = message.loading("切换中...", 0);
    dispatch(showBotLoadingMessage({}));
    const res = await UserService.switchCompany(`${company_id}`);
    dispatch(hideBotLoadingMessage({}));
    hide();
    const token = get(res, "result.token");
    if (token) {
      storage.setToken(token);
      window.location.reload();
    }
  }
);

export const onCompanySelected = createAsyncThunk(
  "user/onCompanySelected",
  async (
    {
      company_name,
      company_id,
    }: {
      abbr: string;
      bot_id: number;
      company_id: number;
      company_name: string;
    },
    thunkAPI
  ) => {
    const state = thunkAPI.getState() as RootState;
    const dispatch = thunkAPI.dispatch;
    if (isLogin()) {
      dispatch(switchCompany({ company_name, company_id }));
      return;
    }
    const loginInfo = mapLoginInfo(state);
    dispatch(setLoginInfo({ companyId: `${company_id}` }));
    dispatch(pushSelfMessage({ payload: company_name }));
    await dispatch(
      login({
        company_id: `${company_id}`,
        phone: loginInfo.loginPhone,
        auth_code: loginInfo.authCode,
      })
    );
  }
);

export const loginSendButtonHandler = createAsyncThunk(
  "user/loginSendButtonHandler",
  async (args: any, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const dispatch = thunkAPI.dispatch;
    const loginInfo = mapLoginInfo(state);
    const flow = getLoginFlow(state.user.loginInfo);
    const inputValue = mapInputValue(state);
    if (flow === LoginFlow.inputPhoneNumber) {
      const isValidPhone = validatePhone(inputValue);
      if (!isValidPhone) {
        confirm({
          title: "手机号格式不正确",
          okText: "确定",
          cancelButtonProps: { style: { display: "none" } },
        });
        return;
      }

      dispatch(setLoginInfo({ loginPhone: inputValue }));
      dispatch(
        pushSelfMessage({
          payload: {
            data: { content: inputValue },
            type: MessageType.client_phone_msg,
          },
        })
      );

      if (loginInfo.signAgreement) {
        await dispatch(sendAuthCode(inputValue));
      } else {
        dispatch(pushBotMessage({ payload: "请签署用户隐私协议" }));
      }

      dispatch(setInputValue(""));
    } else if (
      flow === LoginFlow.inputAuthcode ||
      flow === LoginFlow.choseCompany ||
      flow === LoginFlow.loginWithCode
    ) {
      if (!inputValue) return;
      if (inputValue.length !== 6) {
        confirm({
          title: "验证码为6位数字",
          okText: "确定",
          cancelButtonProps: { style: { display: "none" } },
          // onOk() {
          //   return new Promise((resolve, reject) => {
          //     setTimeout(() => {
          //       resolve({});
          //     }, 1000);
          //   });
          // },
        });
        return;
      }
      dispatch(pushSelfMessage({ payload: inputValue }));
      dispatch(setInputValue(""));
      if (loginInfo.companyId) {
        await dispatch(
          login({
            company_id: loginInfo.companyId,
            phone: loginInfo.loginPhone,
            auth_code: inputValue,
          })
        );
      } else {
        await dispatch(
          getCompanies({
            loginPhone: loginInfo.loginPhone,
            authCode: inputValue,
          })
        );
      }

      dispatch(setLoginInfo({ authCode: inputValue }));
    }
  }
);

function countDown(title: string) {
  let secondsToGo = 3;
  const modal = Modal.success({
    title,
    content: `${secondsToGo}秒后刷新。`,
    onOk: () => {
      window.location.reload();
    },
  });

  let timer: any;

  function fn() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (secondsToGo < 1) {
        clearTimeout(timer);
        modal.destroy();
        window.location.reload();
      } else {
        secondsToGo -= 1;
        modal.update({
          content: `${secondsToGo}秒后刷新。`,
        });
        fn();
      }
    }, 1000);
  }
  fn();
}

let setWorkbenchVisibleLoading = false;

export const setWorkbenchVisible = createAsyncThunk(
  "user/setWorkbenchVisible",
  async ({ checked }: { checked: boolean }, thunkAPI) => {
    if (setWorkbenchVisibleLoading) return;
    setWorkbenchVisibleLoading = true;
    const dispatch = thunkAPI.dispatch;
    try {
      await new Promise((resolve) => setTimeout(resolve, 1));
      const res = await UserService.userCenterSet(checked);
      const success = get(res, "code") === StatusCode.success;
      const msg = get(res, "message", "设置工作台成功");
      if (success) {
        dispatch(setWorkbench(checked));
        countDown(msg);
      } else {
        message.error("设置工作台失败");
        dispatch(setWorkbench(!checked));
      }
    } catch (e) {
      dispatch(setWorkbench(!checked));
      message.error("设置工作台失败");
    }
    setWorkbenchVisibleLoading = false;
  }
);

interface IInitialState {
  bot: Bot;
  userInfo: UserInfo;
  userProfile: UserProfile;
  loginInfo: LoginInfo;
}

const loginInfoInit = {
  companyId: "",
  loginPhone: "",
  signAgreement: false,
  authCode: "",
  authCodeCountdown: sendAuthCodeMinDuration,
};

const botInit = {
  avatar_uuid: "",
  bot_name: "",
  message: "",
  center_view: true,
  locale: "",
  constants: {},
  llm_enable: false
};

const userInfoInit = {
  avatar_id: "",
  company_name: "",
  department_name: "",
  staff_name: "",
  notification_count: 0,
  task_count: 0,
  user_profile_percentage: 0,
  user_type: null,
  parent_department_name: "",
  gender: null,
  position_name: "",
  company_infos: [],
  workbench: false,
};

const userProfileInit = {
  avatar_id: "",
  department: "",
  form: {
    group_list: [],
  },
  form_data: {
    personal_info: {
      id_card_name: "",
      gender: null,
    },
  },
  name: "",
  position: "",
};

const initialState: IInitialState = {
  bot: botInit,
  userInfo: userInfoInit,
  userProfile: userProfileInit,
  loginInfo: loginInfoInit,
};

export const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    resetLoginInfo: (state) => {
      state.loginInfo = loginInfoInit;
    },
    setLoginInfo: (state, action: PayloadAction<Partial<LoginInfo>>) => {
      if (action.payload) {
        state.loginInfo = { ...state.loginInfo, ...action.payload };
      }
    },
    setBot: (state, action: PayloadAction<Bot>) => {
      if (action.payload) {
        state.bot = action.payload;
      }
    },
    setUserInfo: (state, action: PayloadAction<UserInfo>) => {
      if (action.payload) {
        state.userInfo = action.payload;
      }
    },
    setUserProfile: (state, action: PayloadAction<UserProfile>) => {
      if (action.payload) {
        state.userProfile = action.payload;
      }
    },
    resetUserSlice: (state) => {
      Object.assign(state, initialState);
    },
    setWorkbench: (state, action: PayloadAction<boolean>) => {
      state.userInfo.workbench = action.payload;
    },
  },
  extraReducers: {
    [getBot.fulfilled.toString()]: (state, { payload }) => {
      if (payload) {
        state.bot = payload;
      }
    },
    [getUserInfo.fulfilled.toString()]: (state, { payload }) => {
      if (payload) {
        state.userInfo = payload;
      }
    },
    [getUserProfile.fulfilled.toString()]: (state, { payload }) => {
      if (payload) {
        state.userProfile = payload;
      }
    },
  },
});

export const mapBot = (state: RootState) => state.user.bot;
export const mapAuthCodeCountdown = (state: RootState) =>
  state.user.loginInfo.authCodeCountdown;
export const mapUserInfo = (state: RootState) => state.user.userInfo;
export const mapUserProfile = (state: RootState) => state.user.userProfile;
export const mapWorkbenchVisible = createDraftSafeSelector(
  mapUserInfo,
  (userInfo) => userInfo.workbench
);

export const mapBotAvatarId = (state: RootState) => state.user.bot.avatar_uuid;
export const mapUserAvatarId = (state: RootState) =>
  state.user.userInfo.avatar_id;

export const mapUserCenterVisiable = createDraftSafeSelector(mapBot, (bot) =>
  get(bot, "center_view")
);

export const mapBotAvatar = createDraftSafeSelector(mapBotAvatarId, (draft) => {
  return getFilePrefix(draft);
});

export const mapBotName = createDraftSafeSelector(mapBot, (draft) => {
  return draft.bot_name;
});

export const mapUserAvatar = createDraftSafeSelector(
  mapUserAvatarId,
  (draft) => {
    return getFilePrefix(draft);
  }
);

export const mapUserName = createDraftSafeSelector(mapUserInfo, (draft) => {
  return draft.staff_name;
});

export const mapUserType = createDraftSafeSelector(mapUserInfo, (draft) => {
  return draft.user_type;
});

export const mapTaskCount = createDraftSafeSelector(mapUserInfo, (draft) => {
  return draft.task_count;
});

export const mapNotificationCount = createDraftSafeSelector(
  mapUserInfo,
  (draft) => {
    return draft.notification_count;
  }
);

export const mapUserCompanyName = createDraftSafeSelector(
  mapUserInfo,
  (draft) => {
    return formatCompany(draft.company_name);
  }
);

export const mapCompanyInfos = createDraftSafeSelector(mapUserInfo, (draft) => {
  return draft.company_infos;
});

export const mapUserPositionInfo = createDraftSafeSelector(
  mapUserInfo,
  (draft) => {
    return formatPosition(
      draft.parent_department_name,
      draft.department_name,
      draft.position_name
    );
  }
);

export const mapUserProfilePercentage = createDraftSafeSelector(
  mapUserInfo,
  (draft) => {
    return `完成度  ${draft.user_profile_percentage || 0}%`;
  }
);

export const mapLoginInfo = (state: RootState) => state.user.loginInfo;

export function getLoginFlow(login: LoginInfo) {
  if (!login.loginPhone) {
    return LoginFlow.inputPhoneNumber;
  }
  if (!login.signAgreement) {
    return LoginFlow.signAgreement;
  }
  if (!login.authCode) {
    return LoginFlow.inputAuthcode;
  }
  if (!login.companyId) {
    return LoginFlow.choseCompany;
  }
  return LoginFlow.loginWithCode;
}

export const loginFlow = createDraftSafeSelector(mapLoginInfo, (login) => {
  return getLoginFlow(login);
});

export const loginInputPlaceholder = createDraftSafeSelector(
  loginFlow,
  (flow) => {
    if (
      flow === LoginFlow.inputPhoneNumber ||
      flow === LoginFlow.signAgreement
    ) {
      return "请输入手机号";
    }
    if (
      flow === LoginFlow.inputAuthcode ||
      flow === LoginFlow.choseCompany ||
      flow === LoginFlow.loginWithCode
    ) {
      return "请输入你收到的验证码";
    }
    return "";
  }
);

export const loginInputMaxlength = createDraftSafeSelector(
  loginFlow,
  (flow) => {
    if (
      flow === LoginFlow.inputPhoneNumber ||
      flow === LoginFlow.signAgreement
    ) {
      return 20;
    }
    if (
      flow === LoginFlow.inputAuthcode ||
      flow === LoginFlow.choseCompany ||
      flow === LoginFlow.loginWithCode
    ) {
      return 6;
    }
    return;
  }
);

export const {
  resetLoginInfo,
  setLoginInfo,
  setBot,
  setUserInfo,
  setUserProfile,
  resetUserSlice,
  setWorkbench,
} = userSlice.actions;
export default userSlice.reducer;
